import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Alert, AlertType } from '../../models/alert.model';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'alert',
  templateUrl: 'alert.component.html'
})


export class AlertComponent implements OnInit, OnDestroy {
    @Input() id = 'default-alert';
    @Input() fade = true;
    alerts: Alert[] = [];
    alertSubscription!: Subscription;
    routeSubscription!: Subscription;
    clearSubscription!: Subscription;
    closedAlerts: Alert[] = [];

    constructor(private router: Router, private alertService: AlertService) { }

    ngOnInit() {
        // clear alerts on location change
        this.routeSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {

                this.alerts.forEach(a => {
                    if (!a.keepAfterRouteChange){
                        this.removeAlert(a)
                    }
                });

            }
        });

        // subscribe to new alert notifications
        this.alertSubscription = this.alertService.onAlert(this.id)
            .subscribe(alert => {

                if (!alert.message) {
                    // filter out alerts without 'keepAfterRouteChange' flag
                    this.alerts = this.alerts.filter(x => x.keepAfterRouteChange);

                    // remove 'keepAfterRouteChange' flag on the rest
                    this.alerts.forEach(x => delete x.keepAfterRouteChange);
                    return;
                }

                const closedAlerts = JSON.parse(localStorage.getItem('Rapidship:broadcastMessagesClosed' + alert.id)) as Alert[];

                if (closedAlerts) {
                    if (closedAlerts.find(x => x.message == alert.message))
                        return;
                }

                // add alert to array
                this.alerts.push(alert);

                // auto close alert if required
                if (alert.autoClose) {
                    setTimeout(() => this.removeAlert(alert), 3000);
                }
        });

        this.alertSubscription = this.alertService.onClear()
        .subscribe(uniqueId => {
          const index = this.alerts.findIndex(a => a.uniqueId === uniqueId);
          if (index > -1) {
            this.alerts.splice(index, 1);
          }
        });

    }

    ngOnDestroy() {
        // unsubscribe to avoid memory leaks
        this.alertSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
        this.clearSubscription.unsubscribe();
    }

    sortedAlerts() {
        return this.alerts.sort((a,b) => Number(b.lastUpdatedDate) - Number(a.lastUpdatedDate));
    }

    removeAlert(alert: Alert) {
        // check if already removed to prevent error on auto close
        if (!this.alerts.includes(alert)) return;

        // fade out alert if this.fade === true
        const timeout = this.fade ? 0 : 0;
        alert.fade = this.fade;

        this.closedAlerts.push(alert)
        localStorage.setItem('Rapidship:broadcastMessagesClosed' + alert.id, JSON.stringify(this.closedAlerts));

        setTimeout(() => {
            // filter alert out of array
            this.alerts = this.alerts.filter(x => x !== alert);
        }, timeout);
    }

    cssClass(alert: Alert) {
        if (!alert) return;

        const classes = ['alert', 'alert-dismissible'];

        const alertTypeClass = {
            [AlertType.Success]: 'alert-success',
            [AlertType.Error]: 'alert-danger',
            [AlertType.Info]: 'alert-info',
            [AlertType.Warning]: 'alert-warning'
        }

        if (alert.type !== undefined) {
            classes.push(alertTypeClass[alert.type]);
        }

        if (alert.fade) {
            classes.push('fade');
        }

        return classes.join(' ');
    }
}
